<script setup lang="ts">
import { computed } from 'vue'
import type { Component } from 'vue'

interface ActionItem {
  label: string
  icon?: Component
  /** 直显按钮颜色；下拉项若为 danger 会额外标红 */
  type?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'default'
  disabled?: boolean
  /** 下拉菜单中该项上方是否加分隔线 */
  divided?: boolean
  /** 按行数据条件显隐；缺省即始终显示 */
  show?: (row: any) => boolean
  onClick: (row: any) => void
}

const props = withDefaults(
  defineProps<{
    items: ActionItem[]
    row: any
    /** 直显操作数量上限，超出自动收进「更多」；默认 2 */
    maxInline?: number
  }>(),
  { maxInline: 2 }
)

const visibleItems = computed(() =>
  props.items.filter((it) => (it.show ? it.show(props.row) : true))
)
const inlineItems = computed(() => visibleItems.value.slice(0, props.maxInline))
const dropdownItems = computed(() => visibleItems.value.slice(props.maxInline))
</script>

<template>
  <span class="um-op">
    <el-button
      v-for="(item, idx) in inlineItems"
      :key="'inline-' + idx"
      link
      :type="item.type || 'primary'"
      :icon="item.icon"
      :disabled="item.disabled"
      :aria-label="item.label"
      :title="item.label"
      @click="item.onClick(row)"
    >
      {{ item.label }}
    </el-button>

    <el-dropdown v-if="dropdownItems.length" trigger="click">
      <el-button link type="primary">
        更多<el-icon class="el-icon--right"><ArrowDown /></el-icon>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <template v-for="(item, idx) in dropdownItems" :key="'dd-' + idx">
            <el-dropdown-item
              :divided="item.divided"
              :disabled="item.disabled"
              :class="{ 'um-action-danger': item.type === 'danger' }"
              @click="item.onClick(row)"
            >
              <el-icon v-if="item.icon"><component :is="item.icon" /></el-icon>
              <span class="um-action-label">{{ item.label }}</span>
            </el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </span>
</template>

<style scoped>
.um-action-danger {
  color: var(--el-color-danger);
}
.um-action-label {
  margin-left: 4px;
}
</style>
